<template>
  <div class="joinUs">
    <div class="nwrap">
      <div class="nei_ban" >
        <h3>{{$t('m.joinUs')}}<p></p></h3>
      </div>
      <div class="clear ptb3"></div>
      <div class="mainbox wrap">
        <img src="../assets/image/zpimg.jpg" class="zxnsimg">
        <div class="clear"></div>    
      </div>
      <div class="job" v-if="$i18n.locale == 'zh-CN'"> 
        <ul>
          <li>
            <div class="jobtit">
              <div class="wrap">
                <p class="fl">
                  <span>国际贸易经理（2人）<b></b>北京</span>
                </p>
                <a class="fr jobxq">
                  <img src="../assets/img/jian.jpg" class="jian">
                </a>
              </div>
            </div>
            <div class="jobc">
              <div class="wrap">
                <div class="desc" deep="6">
                  <p>
                    <span class="sp1">职位名称：</span><span class="sp2">国际贸易经理（2人）</span><br data-filtered="filtered">
                    <span class="sp1">工作地点：</span><span class="sp2">北京</span><br data-filtered="filtered">
                    <span class="sp1">薪资待遇：</span><span class="sp2">面议</span><br data-filtered="filtered">
                    <span class="sp1">工作职责：</span><span class="sp2"></span>
                  </p>
                  <p>1、负责围绕国际工程承包产生的相关进出口业务；<br data-filtered="filtered">
                    2、全面负责海外工程相关的设备、物资、材料等的进出口业务和配套业务；<br data-filtered="filtered">
                    3、制定营销计划、独立开发、前期选型、谈判、维护指定区域内客户等；<br data-filtered="filtered">
                    4、负责项目投标事务，合同签订、商务谈判及货款的回收；<br data-filtered="filtered">
                    5、负责公司对外考察的各项工作安排；<br data-filtered="filtered">
                    6、负责货物检验、商检报关等过程的跟踪，及时处理各环节出现的问题；<br data-filtered="filtered">
                    7、负责客户信息的收集、归档及客户信用的调查，做好客户要求的及时反馈和处理；<br data-filtered="filtered">
                    8、负责合同履行过程<br data-filtered="filtered">
                    <span class="sp1">任职要求：</span>
                    <span class="sp2"></span>
                  </p>
                  <p>1、本科及以上学历，市场营销、国际贸易等相关专业；<br data-filtered="filtered">
                    2、具备3-5年涉及国际工程领域的国际贸易经验者优先考虑；<br data-filtered="filtered">
                    3、熟悉行业海外市场状况、有海外市场开拓经验；具备较强的客户开发能力和出色的谈判能力；具备出色的外语语言水平；<br data-filtered="filtered">
                    4、具有一定英语口、笔译能力，并能够撰写对外商务信函；<br data-filtered="filtered">
                    5、熟悉进出口业务流程，熟悉外贸进出口业务环节（涉及备货、领证、排载、报关、报检、装船、投保、议付、结汇、退税、索赔等环节）；<br data-filtered="filtered">
                    6、对市场开拓工作有充分的认识，了解国际贸易产品销售及客户
                  </p>
                </div>
              </div>          
            </div>
          </li>
        </ul>
        <div class="dede_pages">
          <ul class="pagelist">
          </ul>
        </div>
      </div>
      <div class="clear ptb2">
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>
.joinUs .nei_ban {
  clear: both;
  width: 100%;
  background: url(../assets/image/1-20042911563SU.jpeg);
  height: 270px;
}
.joinUs .nei_ban {
  background-size: cover!important;
}
.joinUs .nei_ban h3 {
  text-align: center;
  width: 100%;
  clear: both;
  font-size: 48px;
  color: #FFF;
  font-weight: normal;
  padding-top: 105px;
}
.joinUs .nei_ban p {
  font-size: 24px;
  color: #FFF;
  text-transform: uppercase;
}
.joinUs .clear {
  height: 0;
  clear: both;
  zoom: 1;
}
.joinUs .ptb3 {
  padding-top: 3%;
}
.joinUs .wrap {
  width: 1200px;
  margin: 0 auto;
}
.joinUs .mainbox img.zxnsimg {
  margin-top: 50px;
}
.joinUs img {
  max-width: 100%;
}
.joinUs img {
  border: none;
  display: inline-block;
}
.joinUs .job {
  padding: 60px 0px;
}
.joinUs .job ul li {
  margin-bottom: 15px;
}
.joinUs .job ul li .jobtit {
  height: 60px;
  background: #f5f5f5;
  line-height: 60px;
  overflow: hidden;
}
.joinUs .job ul li .jobtit p {
  font-size: 16px;
  color: #666666;
}

.joinUs .job ul li .jobtit p span {
  font-size: 18px;
  color: #222;
  display: inline-block;
  padding-right: 15px;
  font-weight: bold;
}
.joinUs .job ul li .jobtit p span b {
  display: inline-block;
  padding: 0 65px;
}
.joinUs .job ul li .jobtit a.jobxq {
  height: 60px;
  color: #fff;
  padding: 0px 30px;
  font-size: 18px;
}
.joinUs .job ul li .jobtit a.jobxq img {
  vertical-align: middle;
}
.joinUs .job ul li:nth-child(1) .jobc {
  display: block;
}
.joinUs .job ul li .jobc {
  background: #0062b1;
}
.joinUs .job ul li:nth-child(1) .desc {
  display: block;
}
.joinUs .job ul li .desc {
  padding-top: 20px;
  padding-bottom: 30px;
}
.joinUs .job ul li .desc p {
  color: #fff;
  line-height: 28px;
  font-size: 14px;
}
.joinUs .job ul li .desc p span.sp1 {
  display: inline-block;
  width: 70px;
  vertical-align: top;
}
.joinUs .job ul li .desc p span.sp2 {
  display: inline-block;
  width: 1000px;
}
.joinUs .ptb2 {
  padding-top: 2%;
}
.joinUs ul .pagelist {
  text-align: center;
}
@media (max-width: 1300px) {
.joinUs .wrap {
  width: 100% !important;
  padding: 0 15px;
  box-sizing: border-box;
}
.joinUs .job ul li:nth-child(1) .desc {
  display: block;
  padding: 10px;
}
}
@media (max-width: 1000px) {
.joinUs .wrap {
  width: 100% !important;
  padding: 0 15px;
  box-sizing: border-box;
}
.joinUs .job ul li:nth-child(1) .desc {
  display: block;
  padding: 10px;
}
}
@media (max-width: 992px) {
.joinUs .wrap {
  width: 100% !important;
  padding: 0 15px;
  box-sizing: border-box;
}
.joinUs .job ul li:nth-child(1) .desc {
  display: block;
  padding: 10px;
}

}
@media (max-width: 768px) {
.joinUs .wrap {
  width: 100% !important;
  padding: 0 15px;
  box-sizing: border-box;
}
.joinUs .job ul li:nth-child(1) .desc {
  display: block;
  padding: 10px;
}

}
</style>